import store from '@/store'
import i18n from '../../lang'
import {router} from '@/router'
import {mapActions} from 'vuex'
import {
  getCompletionOfRequestsStats,
  getResponseByTimeStats,
  getOffersByServicesStats,
  getOffersByEntitiesStats,
  getOffersByOccupationsStats,
  getOffersByHubsStats,
  getReasonsReplacement,
  topCandidates,
  getActivityCandidates,
  getUsingChannels,
  getCandidateEvolution
} from '@/backend/stats'

const COMPLETION_OF_REQUESTS = 'COMPLETION_OF_REQUESTS';
const SET_OFFERS_BY_SERVICES = 'SET_OFFERS_BY_SERVICES';
const SET_OFFERS_BY_ENTITIES = 'SET_OFFERS_BY_ENTITIES';
const SET_OFFERS_BY_OCCUPATIONS = 'SET_OFFERS_BY_OCCUPATIONS';
const SET_OFFERS_BY_HUBS = 'SET_OFFERS_BY_HUBS';
const SET_REASON_REPLACEMENT = 'SET_REASON_REPLACEMENT';
const SET_RESPONSE_TIME = 'SET_RESPONSE_TIME';
const TOP_CANDIDATES = 'TOP_CANDIDATES';
const ACTIVITY_CANDIDATES = 'ACTIVITY_CANDIDATES';
const USING_CHANNELS = 'USING_CHANNELS';
const CANDIDATE_EVOLUTION = 'CANDIDATE_EVOLUTION';
const SET_FULL_PAGE = 'SET_FULL_PAGE';
const SET_ENTITY = 'SET_ENTITY';
const SET_STATE_FILTER = 'SET_STATE_FILTER'

const state = {
  completionOfRequests: {},
  offersByServicesStats: {},
  offersByEntitiesStats: {},
  offersByOccupationsStats: {},
  offersByHubsStats: {},
  reasonsReplacementStats: {},
  responseByTime: {},
  topCandidates: {},
  activityCandidates: {},
  usingChannels: {},
  candidateEvolution: {},
  isFullPage: false,
  selectedEntity: null,
  filters_display: {
    replaced_occupation_id_in: '',
    replaced_service_id_in: '',
    hub_id_in: '',
    entity_id_in: null
  }
};

export const mutations = {
  [COMPLETION_OF_REQUESTS](state, completionOfRequests) {
    state.completionOfRequests = completionOfRequests
  },
  [SET_OFFERS_BY_SERVICES](state, offersByServicesStats) {
    state.offersByServicesStats = offersByServicesStats
  },
  [SET_OFFERS_BY_ENTITIES](state, offersByEntitiesStats) {
    state.offersByEntitiesStats = offersByEntitiesStats
  },
  [SET_OFFERS_BY_OCCUPATIONS](state, offersByOccupationsStats) {
    state.offersByOccupationsStats = offersByOccupationsStats
  },
  [SET_OFFERS_BY_HUBS](state, offersByHubsStats) {
    state.offersByHubsStats = offersByHubsStats
  },
  [SET_REASON_REPLACEMENT](state, reasonsReplacementStats) {
    state.reasonsReplacementStats = reasonsReplacementStats
  },
  [SET_RESPONSE_TIME](state, responseByTime) {
    state.responseByTime = responseByTime
  },
  [TOP_CANDIDATES](state, topCandidates) {
    state.topCandidates = topCandidates
  },
  [ACTIVITY_CANDIDATES](state, activityCandidates) {
    state.activityCandidates = activityCandidates
  },
  [USING_CHANNELS](state, usingChannels) {
    state.usingChannels = usingChannels
  },
  [CANDIDATE_EVOLUTION](state, candidateEvolution) {
    state.candidateEvolution = candidateEvolution
  },
  [SET_FULL_PAGE](state, status) {
    state.isFullPage = status
  },
  [SET_ENTITY](state, entity) {
    state.selectedEntity = entity
  },
  [SET_STATE_FILTER](state, filter) {
    state.filters_display = filter
  }
};

export const actions = {
  getCompletionOfRequestsStats({commit}, params) {
    return getCompletionOfRequestsStats(params)
      .then((response) => {
        commit(COMPLETION_OF_REQUESTS, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },

  getResponseByTimeStats({commit}, params) {
    return getResponseByTimeStats(params)
      .then((response) => {
        commit(SET_RESPONSE_TIME, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },

  getOffersByServicesStats({commit}, params) {
    return getOffersByServicesStats(params)
      .then((response) => {
        commit(SET_OFFERS_BY_SERVICES, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },

  getOffersByEntitiesStats({commit}, params) {
    return getOffersByEntitiesStats(params)
      .then((response) => {
        commit(SET_OFFERS_BY_ENTITIES, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },

  getOffersByOccupationsStats({commit}, params) {
    return getOffersByOccupationsStats(params)
      .then((response) => {
        commit(SET_OFFERS_BY_OCCUPATIONS, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },

  getOffersByHubsStats({commit}, params) {
    return getOffersByHubsStats(params)
      .then((response) => {
        commit(SET_OFFERS_BY_HUBS, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },

  getReasonsReplacement({commit}, params) {
    return getReasonsReplacement(params)
      .then((response) => {
        commit(SET_REASON_REPLACEMENT, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },

  topCandidates({commit}, params) {
    return topCandidates(params)
      .then((response) => {
        commit(TOP_CANDIDATES, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },

  getActivityCandidates({commit}, params){
    return getActivityCandidates(params)
      .then((response) => {
        commit(ACTIVITY_CANDIDATES, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },

  getUsingChannels({commit}, params) {
    return getUsingChannels(params)
      .then((response) => {
        commit(USING_CHANNELS, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },

  getCandidateEvolution({commit}, params) {
    return getCandidateEvolution(params)
      .then((response) => {
        commit(CANDIDATE_EVOLUTION, response.data)
      })
      .catch((error) => {
        store.dispatch('message/enable',
          {type: 'danger', content: error.response.data.error})
      })
  },
  setFullPage({commit}, status) {
    commit(SET_FULL_PAGE, status)
  },
  setEntity({commit}, entity) {
    commit(SET_ENTITY, entity)
  },
  setStateFilter({commit}, filter) {
    commit(SET_STATE_FILTER, filter)
  }
};

export const getters = {
  completionOfRequests: state => state.completionOfRequests,
  offersByServicesStats: state => state.offersByServicesStats,
  offersByEntitiesStats: state => state.offersByEntitiesStats,
  offersByOccupationsStats: state => state.offersByOccupationsStats,
  offersByHubsStats: state => state.offersByHubsStats,
  reasonsReplacementStats: state => state.reasonsReplacementStats,
  responseByTime: state => state.responseByTime,
  topCandidates: state => state.topCandidates,
  activityCandidates: state => state.activityCandidates,
  usingChannels: state => state.usingChannels,
  candidateEvolution: state => state.candidateEvolution,
  isFullPage: state => state.isFullPage,
  selectedEntity: state => state.selectedEntity,
  filters_display: state => state.filters_display
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/stats.js